<script>
  export default {
    props: ['data', 'callbacks', 'template'],
    template: '', //Set dynamically on create
    methods: {
      play() {
        if (this.callbacks && this.callbacks.play) {
          this.callbacks.play(this.data);
        } else {
          if (this.data.type === 'Embedded Video') {
            this.showResourceInfoModal();
          } else {
            Kadenze.MediaFileActions.play(this.data);
          }
        }
      },
      preview() {
        if (this.callbacks && this.callbacks.preview) {
          this.callbacks.preview(this.data);
        } else {
          this.hideResourceInfoModal();
          Kadenze.MediaFileActions.preview(this.data);
        }
      },
      queue() {
        Kadenze.MediaFileActions.queue(this.data);
      },
      hideResourceInfoModal() {
        let $resourceInfoModal = $('#resource_info_modal');
        $resourceInfoModal.modal('hide');
      },
      showResourceInfoModal() {
        console.log('showResourceInfoModal');
        let $resourceInfoModal = $('#resource_info_modal');
        let vm = ko.dataFor($resourceInfoModal[0]);
        vm.selectedResource(new Kadenze.GenericFileViewModel(this.data, $(this.$el), {}));
        $resourceInfoModal.modal('show');
      },
      showResourceShareModal() {
        this.hideResourceInfoModal();
        let params = {
          modal_title: 'Share this Resource',
          modal_description: 'Only individuals enrolled in the course will have access to this resource.',
          privateSharing: true,
          shareableObj: { share_url: this.data.path }
        };
        let modal = new Kadenze.ShareModal(params);
        modal.show();
      }
    },
    created() {
      this.$options.template = this.template;
    }
  }
</script>